import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './Help.css';
import { changeTextInput } from "../actions/betActions"

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData
    };
};
class Help extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
    }

    changeTextInput(event) {
        this.props.dispatch(changeTextInput(event.target.name, event.target.value, "HELP"));
    }

    viewProposal(event) {

    }

    render() {  
        
      return (
        <div>
          <div className="section">
            <div className="sectionTitle">FAQ</div>

            <div className="labelInputGroup moveTop20">How do I get an Ethereum address?</div>
            <div><label className="splashLightText moveTop10">Install <a target="_blank" className="bluelink" href={"https://metamask.io/"}>Metamask</a>, 
            a browser extension available for the Chrome, Firefox, and Opera web browsers. Follow the instructions for creating an address.
            You'll need to have your Metamask account unlocked to use most of Ethbet's functionality.</label></div>

            <div className="labelInputGroup moveTop20">How do I get some Ethereum (ETH) so that I can bet with it?</div>
            <div><label className="splashLightText moveTop10">The easiest way is to buy it from an exchange using your local currency.
            One user-friendly option is <a target="_blank" className="bluelink" href={"https://coinbase.com"}>Coinbase</a>.
            You'll need to send the ETH from the exchange to the Ethereum address you created with Metamask.</label></div>

            <div className="labelInputGroup moveTop20">What if I'm not a twitter user?</div>
            <div><label className="splashLightText moveTop10">
            You should <a target="_blank" className="bluelink" href={"https://twitter.com/signup"}>sign up</a> for a new account. 
            People who don't already trust you will be more willing to bet with you the more associated your 
            Twitter username is with an identity that you care about.</label></div>

            <div className="labelInputGroup moveTop20">I don't want to pay an arbitration fee. How can I avoid doing so?</div>
            <div><label className="splashLightText moveTop10">You'll never have to pay an arbitration fee
            unless you disagree with both the arbiter and your opponent about the outcome of the bet. 
            A reliable strategy for never paying an arbitration fee is to 
            only participate in bets with clear outcome criteria, and to ensure that at least your opponent or the arbiter cares enough about
            their reputation to not want to publicly lie about the bet outcome.</label></div> 

            <div className="labelInputGroup moveTop20">How can I find an arbiter for my bet?</div>
            <div><label className="splashLightText moveTop10">The simplest way is to ask a spectator of your Internet argument who you and your
            opponent think is unlikely to publicly lie. Ethbet also offers an arbitration service which you can use by leaving the default setting for 
            arbitraiton as "@ethbetapp".</label></div>

            <div className="labelInputGroup moveTop20">Why should I trust my opponent and/or the arbiter?</div>
            <div><label className="splashLightText moveTop10">We've carefully designed our system so that all participants have incentives to report bet outcomes honestly.
            The details are described here. [LINK TO BOTTOM OF SPLASH PAGE]</label></div>

            <div className="labelInputGroup moveTop20">How do I know that the contract which controls my bet is trustworthy?</div>
            <div><label className="splashLightText moveTop10">We publish the contract code here[LINK]. Instructions for verifying that the code we've 
            published matches the code you're sending your money to are here[LINK]. This page[LINK] contains a list of Twitter users who have read our contract code and
            attested that it looks correct to them. Their attestations are provided as proof. If you know how to read Solidity code, we welcome
            you to review our smart contract and send us your thoughts about its quality.[INCLUDE EMAIL]</label></div>

            <div className="labelInputGroup moveTop20">How do I know the person I'm betting with on Ethbet is
            really the twitter user with the same username?</div>
            <div><label className="splashLightText moveTop10">We require that all Ethbet users have an visible Twitter 
            post claiming control of their Ethereum address. We also require that they the controller of the Ethereum address sends us a signed message
            claiming control of the Twitter account. This proves that the same entity controls both sources. These proofs are available for you to
            review on any user's Ethbet page.</label></div>

            <div className="labelInputGroup moveTop20">Why did you create this site?</div>
            <div><label className="splashLightText moveTop10">We believe Internet discussions contain too little careful reasoning and 
            truth-seeking, and too much posturing and bullshit. 
            Our hope is that making it very easy to challenge people to bets will improve the quality of Internet discussion by 
            increasing the frequency of bet offers and making people think twice before making unreasonable claims with unjustified confidence.</label></div>


            <div className="labelInputGroup moveTop20">Question</div>
            <div><label className="splashLightText moveTop10">Some text.</label></div>

          </div>
       </div>
      );
    }
  }
  
  export default connect(stateMap)(Help);



// WEBPACK FOOTER //
// ./src/components/Help.js